module.exports = __webpack_public_path__ + "media/images/lp_reason-5-d7da570f5efcd7c7539f3c98f8b57532.webp";